export default __webpack_public_path__ + "static/media/logo.11ef1b1c.jpg";